import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import $ from 'jquery';
import 'datatables.net-bs4';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { jwtDecode } from "jwt-decode";

const CloseTicket = () => {
  const tableRef = useRef(null);
  const [tickets, setTickets] = useState([]);
  const [userRole, setUserRole] = useState(null); // State for role

  useEffect(() => {
        const token = localStorage.getItem("authToken");
        if (token) {
          try {
            const decodedToken = jwtDecode(token);
            setUserRole(parseInt(decodedToken.RoleBaseId)); // Update state with role
          } catch (error) {
            console.error("Error decoding token:", error);
            localStorage.removeItem("authToken"); // Remove invalid token
          }
        }
      }, []); // Runs only on mount

  useEffect(() => {
    const fetchUserTickets = async () => {
      if (userRole === null) return;
    
      try {
        const authToken = localStorage.getItem("authToken");
    
        // Correct way to use Promise.all
        const [activeResponse, closedResponse] = await Promise.all([
          //fetch(`http://localhost:5121/api/RiseTicket/active`, {
          fetch(`https://apiv2.chakran.in/api/RiseTicket/active`, {
            headers: { Authorization: `Bearer ${authToken}` },
          }),
         // fetch(`http://localhost:5121/api/RiseTicket/closed`, {
          fetch(`https://apiv2.chakran.in/api/RiseTicket/closed`, {
            headers: { Authorization: `Bearer ${authToken}` },
          }),
        ]);
    
        // Check if both responses are OK
        if (!activeResponse.ok) {
          throw new Error(`Failed to fetch active tickets: ${activeResponse.status}`);
        }
        if (!closedResponse.ok) {
          throw new Error(`Failed to fetch closed tickets: ${closedResponse.status}`);
        }
    
        // Convert responses to JSON
        const activeData = await activeResponse.json();
        const closedData = await closedResponse.json();
    
        console.log("Active Tickets:", activeData);
        console.log("Closed Tickets:", closedData);
    
        setTickets([...activeData, ...closedData]); // Merge both lists
      } catch (error) {
        console.error("Error fetching tickets:", error.message);
      }
    };    

    fetchUserTickets();
  }, [userRole]); // Refetch when `userId` updates

  useEffect(() => {
    if (tableRef.current && tickets.length > 0) {
      const table = $(tableRef.current).DataTable({
        data: tickets,
        columns: [
          { data: "subject", title: "Ticket" },
          { data: "message", title: "Message" },
          { data: "startDate", title: "Date" },
          { data: "status", title: "Status" },
        ],
        destroy: true, // Prevent duplicate table initialization
      });

      return () => table.destroy();
    }
  }, [tickets]); // Re-run when `tickets` update

  return (
    <>
      <div className="container">
        <div className="card card-default card-profile px-6 py-4">
          <div className="row">
            <div className="col-md-6">
              <h2 className="h5 d-block mt-3 mb-2">My Closed Tickets</h2>
            </div>
            <div className="col-md-6 text-right">
              <Link className="btn btn-primary btn-pill" to="/dashboard/open-new-ticket">
                Open New Ticket
              </Link>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-12">
              <div className="card card-default">
                <div className="card-body">
                  <table ref={tableRef} className="table table-bordered table-hover" style={{ width: "100%" }}>
                    <thead>
                      <tr>
                        <th>Ticket</th>
                        <th>Start Date</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody></tbody> {/* DataTable will populate this */}
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CloseTicket;
